import Data from 'data';

export const legendaryGems = {
  powerful: {
    check: true,
    active: false,
    buffs(level, stats) {
      const buffs = {dmgmul: 20};
      if (level >= 25) {
        buffs.edmg = 15;
        buffs.edef = 15;
      }
      return buffs;
    },
    inactive(level, stats) {
      if (level >= 25) return {edmg: 15, edef: 15};
    },
  },
  trapped: {
    active: true,
  },
  hoarder: {
    active: false,
  },
  enforcer: {
    always: true,
    active: true,
    buffs(level, stats) {
      return {dmgmul: {pet: true, percent: 15 + level * 0.3}};
    },
  },
  esoteric: {
    always: true,
    active: true,
  },
  ease: {
    always: true,
    active: true,
  },
  toxin: {
    active: true,
    info(level, stats) {
      return {"DPS": {elem: "psn", coeff: 20 + 0.5 * level, divide: {"Duration": 10}, total: true}};
    },
  },
  gogok: {
    active: true,
    params: [{min: 0, max: 15, name: "Stacks"}],
    buffs(level, stats) {
      const res = {ias: this.params[0].val, dodge: (0.5 + 0.01 * level) * this.params[0].val};
      if (level >= 25) {
        res.cdr = res.ias;
      }
      return res;
    },
  },
  invigorating: {
    buffs(level, stats) {
      if (level >= 25) return {ccr: 100};
    },
  },
  mirinae: {
    info(level, stats) {
      return {"Damage": {elem: "hol", coeff: 30 + 0.6 * level}};
    },
  },
  gizzard: {
    always: true,
    active: true,
  },
  moratorium: {
  },
  pain: {
    info(level, stats) {
      return {"DPS": {elem: "phy", coeff: 25 + 0.5 * level, divide: {"Duration": 3}, total: true}};
    },
//    active: false,
//    check: true,
    params: [{min: 0, max: 30, inf: 25, val: 0, name: "Stacks", show(stats) {
              return stats.gems.pain >= 25;
            }}],
    buffs(level, stats) {
      if (level >= 25) {
        return {ias: this.params[0].val * 3};
      }
    },
  },
  simplicity: {
    always: true,
    active: true,
    buffs(level, stats) {
      const value = 25 + level * 0.5;
      const skills = [];
      for (var skill in Data.skills[stats.charClass]) {
        if (Data.skills[stats.charClass][skill].category === "primary") {
          skills.push(skill);
          //res["skill_" + stats.charClass + "_" + skill] = value;
        }
      }
      return {dmgmul: {skills: skills, percent: value}};
    },
  },
  taeguk: {
    active: true,
    params: [{min: 0, max: 10, name: "Stacks"}],
    buffs(level, stats) {
      const res = {damage: (2 + level * 0.04) * this.params[0].val};
      if (level >= 25) {
        res.armor_percent = 2 * this.params[0].val;
      }
      return res;
    },
  },
  wreath: {
    active: false,
    info(level, stats) {
      return {"Damage": {elem: "lit", coeff: 12.5 + 0.25 * level, total: true}};
    },
  },
  zei: {
    active: true,
    params: [{min: 0, max: 40, step: 10, name: "Distance"}],
    buffs(level, stats) {
      return {dmgmul: (this.params[0].val + 10) * (4 + 0.08 * level) / 10};
    },
  },

  stricken: {
    active: true,
    params: [{min: 0, max: 50, name: "Stacks", inf: true}],
    buffs(level, stats) {
      const res = {dmgmul: this.params[0].val * (0.8 + 0.01 * level)};
      if (level >= 25) res.bossdmg = 25;
      return res;
    },
  },
  iceblink: {
    active: true,
  },
  mutilation: {
  },
  boyarsky: {
    always: true,
    active: true,
  },
  soulshard: {
    check: true,
    active: false,
    info(level, stats) {
      return {"Damage": {elem: "fir", coeff: 125 + 0.5 * level}};
    },
    buffs(level, stats) {
      if (level >= 25) return {cdr: 75, rcr: 100};
    },
  },
  legacyofdreams: {
    active: true,
    buffs(level, stats) {
      for (const id in stats.info.sets) {
        if (stats.info.sets[id] <= 1) continue;
        const count = stats.info.sets[id] + (stats.leg_ringofroyalgrandeur ? 1 : 0);
        for (const num in Data.itemSets[id].bonuses) {
          if (num <= count) return;
        }
      }
      const items = stats.info.legendaries + stats.info.ancients;
      return {dmgmul: 3.75 * (level + 1) * items, dmgred: 2 * items};
    },
  },
};
